export var NLPSearchResultFormat = /*#__PURE__*/function (NLPSearchResultFormat) {
  NLPSearchResultFormat["PLAINTEXT"] = "PLAIN_TEXT";
  NLPSearchResultFormat["ADF"] = "ADF";
  NLPSearchResultFormat["JSON"] = "JSON";
  NLPSearchResultFormat["MARKDOWN"] = "MARKDOWN";
  return NLPSearchResultFormat;
}({});
export var NLPSearchJSONResultFormat = /*#__PURE__*/function (NLPSearchJSONResultFormat) {
  NLPSearchJSONResultFormat["WHO"] = "who";
  NLPSearchJSONResultFormat["WORK"] = "work";
  NLPSearchJSONResultFormat["TEAM"] = "team";
  NLPSearchJSONResultFormat["PERSON"] = "person";
  return NLPSearchJSONResultFormat;
}({});
export var NLPSearchDisclaimerType = /*#__PURE__*/function (NLPSearchDisclaimerType) {
  NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
  return NLPSearchDisclaimerType;
}({});
export var NLPSearchErrorState = /*#__PURE__*/function (NLPSearchErrorState) {
  NLPSearchErrorState["NoAnswer"] = "NO_ANSWER";
  NLPSearchErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
  NLPSearchErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
  NLPSearchErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
  NLPSearchErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
  NLPSearchErrorState["NoAnswerOpenAIResponseError"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
  NLPSearchErrorState["NoAnswerOpenAIRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
  NLPSearchErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
  NLPSearchErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
  NLPSearchErrorState["AcceptableUseViolation"] = "ACCEPTABLE_USE_VIOLATIONS";
  NLPSearchErrorState["AIDisabled"] = "AI_DISABLED";
  // These values are not returned from the BE and are only used by the FE
  NLPSearchErrorState["Default"] = "DEFAULT";
  // Value at component initialization
  NLPSearchErrorState["NetworkError"] = "NETWORK_ERROR";
  // Value if the network call fails
  NLPSearchErrorState["TimeoutError"] = "TIMEOUT_ERROR"; // Value if the network call times out
  return NLPSearchErrorState;
}({});
export var NLPSearchResultContainerDataTypeContainerType = /*#__PURE__*/function (NLPSearchResultContainerDataTypeContainerType) {
  NLPSearchResultContainerDataTypeContainerType["ConfluenceSpace"] = "confluenceSpace";
  NLPSearchResultContainerDataTypeContainerType["JiraProject"] = "jiraProject";
  return NLPSearchResultContainerDataTypeContainerType;
}({});
export var NLPSearchCustomDefinitionType = /*#__PURE__*/function (NLPSearchCustomDefinitionType) {
  NLPSearchCustomDefinitionType["CURATED"] = "CURATED";
  NLPSearchCustomDefinitionType["PRECOMPUTED"] = "PRECOMPUTED";
  return NLPSearchCustomDefinitionType;
}({});

// will work with BE to standardize nlpResult in schema between gql and REST

export var AIAnswerQueryStreamType = /*#__PURE__*/function (AIAnswerQueryStreamType) {
  AIAnswerQueryStreamType["AnswerType"] = "ANSWER_TYPE";
  AIAnswerQueryStreamType["AnswerPart"] = "ANSWER_PART";
  AIAnswerQueryStreamType["FinalResponse"] = "FINAL_RESPONSE";
  return AIAnswerQueryStreamType;
}({});

/**
 * Overloading the return type of the query function to allow for setting up
 * a v2 getAnswer.
 */

export var AIAnswerAPIType = /*#__PURE__*/function (AIAnswerAPIType) {
  AIAnswerAPIType["STREAM"] = "STREAM";
  return AIAnswerAPIType;
}({});

/**
 * The return type is overloaded here to minimise the impact of the change towards
 * v2 with streaming.
 */

export var DefinitionAnswerState = /*#__PURE__*/function (DefinitionAnswerState) {
  DefinitionAnswerState["LOADING"] = "loading";
  DefinitionAnswerState["ANSWERED"] = "answered";
  DefinitionAnswerState["ERRORED"] = "errored";
  return DefinitionAnswerState;
}({});